import React, { FC, Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import { Grid, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import { ClientGroupSourceFragment, SourceStatus } from 'api';
import { useGroupSources } from 'features/groups/hooks';

import Source from './Source';
import SourceCreate from './SourceCreate';

const useStyles = makeStyles(theme => ({
  space: {
    marginTop: theme.spacing(4),
  },
}));

const Sources: FC = () => {
  const classes = useStyles();
  const { t } = useTranslation();
  const { sources } = useGroupSources();

  const activeSources = sources.filter(source => source.source_status === SourceStatus.Active);
  const inactiveSources = sources.filter(source => source.source_status === SourceStatus.Disabled);

  function renderSource(source: ClientGroupSourceFragment) {
    return (
      <Grid item xs={12} key={source.id}>
        <Source source={source} />
      </Grid>
    );
  }

  return (
    <Fragment>
      <SourceCreate />
      {!!activeSources.length && (
        <Typography
          color="textSecondary"
          variant="subtitle1"
          gutterBottom
          className={classes.space}
        >
          {t('groups:sourcesActive')}
        </Typography>
      )}
      <Grid container spacing={3} direction="column" wrap="nowrap">
        {activeSources.map(renderSource)}
      </Grid>

      {!!inactiveSources.length && (
        <Typography
          color="textSecondary"
          variant="subtitle1"
          gutterBottom
          className={classes.space}
        >
          {t('groups:sourcesInactive')}
        </Typography>
      )}
      <Grid container spacing={3} direction="column" wrap="nowrap">
        {inactiveSources.map(renderSource)}
      </Grid>
    </Fragment>
  );
};

export default Sources;
